"use client";

import Image from "next/image";
import Link from "next/link";
import { trackEvent } from "@/lib/analytics";
import { EVENT } from "@/lib/analytics-events";

type SocBadgeVariant = "color" | "black";

type SocBadgeProps = {
  variant?: SocBadgeVariant;
  size?: number;
  className?: string;
  linkClassName?: string;
  /**
   * Opt-in analytics. When set, clicks fire `marketing_footer_clicked` with
   * this value as `link_id`. Footers pass `"footer_soc2_badge"`; body-section
   * placements leave it unset so badge clicks there aren't mislabeled as
   * footer clicks.
   */
  trackingLinkId?: string;
};

const BADGE_SRC: Record<SocBadgeVariant, string> = {
  color: "/brand/soc/aicpa-soc-badge.png",
  black: "/brand/soc/aicpa-soc-badge-black.png",
};

const SOC_HREF = "https://www.aicpa.org/soc4so";

export default function SocBadge({
  variant = "color",
  size = 96,
  className,
  linkClassName,
  trackingLinkId,
}: SocBadgeProps) {
  return (
    <Link
      href={SOC_HREF}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="AICPA SOC for Service Organizations - learn more at aicpa.org/soc4so"
      className={linkClassName}
      onClick={
        trackingLinkId
          ? () =>
              trackEvent(EVENT.marketing_footer_clicked, {
                link_id: trackingLinkId,
                destination: SOC_HREF,
              })
          : undefined
      }
    >
      <Image
        src={BADGE_SRC[variant]}
        alt="AICPA SOC for Service Organizations"
        width={size}
        height={size}
        className={className}
        priority={false}
      />
    </Link>
  );
}
